import * as z from 'zod';
import { VectorTileAddEditService } from './VectorTileAddEditService';
import { VectorTileListServices } from './VectorTileListServices';
import { useLocalization } from '@ais-ui/locale-management';
import { useVectorTileSettings } from '../../VectorTiles/useVectorTileSettings';

export function VectorTileForm() {
  const { messages } = useLocalization();
  const vectorTiles = useVectorTileSettings();

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">
          {messages.settingsWmsServicesTitle}
        </h3>
        {vectorTiles.length > 0 && (
          <VectorTileAddEditService mode="create"></VectorTileAddEditService>
        )}
      </div>
      <VectorTileListServices></VectorTileListServices>
    </div>
  );
}
